import { render, staticRenderFns } from "./menuStatusFlow.vue?vue&type=template&id=50beb762&scoped=true"
import script from "./menuStatusFlow.vue?vue&type=script&lang=js"
export * from "./menuStatusFlow.vue?vue&type=script&lang=js"
import style0 from "./menuStatusFlow.vue?vue&type=style&index=0&id=50beb762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50beb762",
  null
  
)

export default component.exports